import { connect } from "react-redux";
import IlomeModalContainer from "./IlomeModalContainer";
import { putNormalizedEntities } from "../../../../helpers";
import { hideModal } from "../../../../actions/modals";
import { showToast } from "../../../../actions/toasts";

const mapStateToProps = (state, props) => {
    const {
        entities: { ceremonies },
    } = state;

    const { ceremonyId } = props;

    let ceremony = ceremonies.byId[ceremonyId];

    return {
        ceremony: ceremony.item,
        isVisible: true,
        ceremonyId: props.ceremonyId,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        updateStoreEntities: (entities) => {
            putNormalizedEntities(dispatch, entities);
        },
        hideModal: () => dispatch(hideModal()),
        showToast: (options) => dispatch(showToast(options)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(IlomeModalContainer);
